import React, { Component } from 'react';
import {Form, Button} from 'semantic-ui-react';

class CopyLink extends Component {
    copyLink(e,data){
        if(e.clipboardData){
            e.clipboardData.setData(data);
        }
    }
  render() {
    return (
      <div>
          <Form.Group >
            <Form.Field>
                <input value={this.props.data} />
            </Form.Field>
            <Form.Field>
                <Button onClick={this.copyLink.bind(this, this.props.data)}>Copy Link</Button>
            </Form.Field>
          </Form.Group>
      </div>
    )
  }
}
export default CopyLink;


// WEBPACK FOOTER //
// ./src/HomeComponents/FileUpload/CopyLink.js